
import template from "./menuElement.hbs";

import { initMenuLeafNodeWebComponent, MenuLeafNodeElement } from "./menuLeafNodeElement";
import { initMenuParentNodeWebComponent, MenuParentNodeElement } from "./menuParentNodeElement";

import "./menu.scss";
import { MenuEntries } from "./sideMenu";
import Mousetrap from "mousetrap";
import { FocusManager } from "components/pages/focusManager";

export class MenuElement extends HTMLElement {
    private menuDefinition: MenuEntriesWithEnvironment;

    constructor() {
        super();

        Mousetrap(this).bind(['down'], () => {
            FocusManager.focusNext(this);
            return false;
        });
        Mousetrap(this).bind(['up'], () => {
            FocusManager.focusPrevious();
            return false;
        });
    }

    public connectedCallback() {
        this.innerHTML = template({
        });
        for (const entry of this.menuDefinition.entries) {
            let element: HTMLElement;
            if (entry.children == null) {
                element = document.createElement("s6-menu-node-leaf");
                (element as MenuLeafNodeElement).entry = {
                    ...entry,
                    environment: this.menuDefinition.environment,
                    level: 0,
                    appPrefix: this.menuDefinition.appPrefix
                };
            } else {
                element = document.createElement("s6-menu-node-parent") as MenuParentNodeElement;
                (element as MenuParentNodeElement).model = {
                    entries: entry.children,
                    environment: this.menuDefinition.environment,
                    level: this.menuDefinition.level,
                    appPrefix: this.menuDefinition.appPrefix,
                    key: entry.key
                };
            }
            element.setAttribute("key", entry.key)
            this.append(element)
            window.addEventListener('hashchange', this.hashChangeListener);
            this.hashChangeListener();
        }
    }
    public disconnectedCallback() {
        window.removeEventListener('hashchange', this.hashChangeListener);
    }

    public setMenu(definition: MenuEntriesWithEnvironment) {
        this.menuDefinition = definition;
        this.connectedCallback();
    }
    public focus() {
        this.querySelector("a").focus();
    }
    private hashChangeListener = () => {
        let screenId: string;
        if (window.location.hash.startsWith("#!/l/")) {
            screenId = window.location.hash.split("/").slice(-1)[0].split(".").slice(-1)[0].split("?")[0];
        } else {
            screenId = window.location.hash.split("/").slice(-1)[0].split("?")[0];
            // For LDS that chan link to contents in page
            if (screenId.startsWith("#")) {
                screenId = window.location.hash.split("/").slice(-2)[0].split("?")[0];
            }
        }
        this.querySelectorAll("s6-menu-node-leaf").forEach(n => (n as MenuLeafNodeElement).active = screenId)
    }
}

export function initMenuWebComponent() {
    window.customElements.define("s6-menu", MenuElement);
    initMenuLeafNodeWebComponent();
    initMenuParentNodeWebComponent();
}

export interface MenuEntriesWithEnvironment extends MenuEntries {
    environment: object;
    appPrefix: string;
    level: number;
}
